import {Component} from '@angular/core';
import {MenuItem} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
import { Button } from 'primeng/button';
import { DrawerModule } from 'primeng/drawer';
import { PanelMenuModule } from 'primeng/panelmenu';

@Component({
    selector: 'app-nav',
    templateUrl: './nav.component.html',
    styleUrls: ['./nav.component.css'],
    imports: [Button, DrawerModule, PanelMenuModule]
})
export class NavComponent {

	menuItems: MenuItem[];

	sidebarVisible: boolean;

	showSidebar = () => {
		this.sidebarVisible = true;
	};

	hideSidebar = () => {
		this.sidebarVisible = false;
	};

	constructor(private translateService: TranslateService) {
		this.buildMenu();
		this.translateService.onLangChange.subscribe(event => this.buildMenu());
	}

	buildMenu(){
		this.menuItems = [
			{
				label: this.translateService.instant('app.menu.cycleCount'),
				routerLink: '/cycle-count',
				command: this.hideSidebar,
				icon: 'pi pi-check-square',
				visible: true
			},
			{
				label: this.translateService.instant('app.menu.audit'),
				routerLink: '/audit',
				command: this.hideSidebar,
				icon: 'pi pi-eye',
				visible: true
			},
			{
				label: this.translateService.instant('app.menu.inbound'),
				routerLink: '/inbound',
				command: this.hideSidebar,
				icon: 'pi pi-arrow-circle-up',
				visible: true
			},
			{
				label: this.translateService.instant('app.menu.outbound'),
				routerLink: '/outbound',
				command: this.hideSidebar,
				icon: 'pi pi-shopping-cart',
				visible: true
			},
			{
				label: this.translateService.instant('app.menu.manageWaherouse'),
				routerLink: '/manage-warehouse',
				command: this.hideSidebar,
				icon: 'pi pi-share-alt',
				visible: true
			},
			{
				label: this.translateService.instant('app.menu.settings'),
				routerLink: '/settings',
				command: this.hideSidebar,
				icon: 'pi pi-cog',
				visible: true
			},
			{
				label: this.translateService.instant('app.menu.inConstruction'),
				routerLink: '/construction',
				command: this.hideSidebar,
				icon: 'pi pi-question',
				visible: !environment.production
			},
			{
				label: this.translateService.instant('app.menu.logout'),
				routerLink: '/logout',
				command: this.hideSidebar,
				icon: 'pi pi-sign-out',
				visible: true
			}
		];
	}
}

